import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import Debug from '@/components/debug';
import { ALGOLIA_INDEX_NAME, searchClient } from '@/lib/algolia/searchClient';
import { GetStaticPropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { getCanonicalPath } from '@/lib/algolia/getCanonicalPath';
import historicPaths from '../data/historicPaths.json';
import categorySlugs from '../data/categorySlugs.json';
import categories from '../data/categories.json';
import { configuredSanityClient } from '@/lib/sanity/sanityClient';
import groq from 'groq';
import { Redirect } from '@fagmobler/sanity';

export type RedirectPageProps = {};

export const RedirectPage = (props: RedirectPageProps) => {
  return (
    <div>
      <h1>Redirect</h1>
      <Debug data={props} />
    </div>
  );
};

export const getRedirectData = async ({
  context,
  slugs,
}: {
  context: GetStaticPropsContext<ParsedUrlQuery>;
  slugs: string[];
}) => {
  if (slugs[0] === 'serieinfo') {
    return {
      props: {},
      redirect: {
        destination: `/serie/${slugs[1]}`,
        permanent: true,
      },
    };
  }
  const currentPath = `/${slugs.join('/')}`;
  let newUrl: string | null = `/rom/${slugs.join('/')}`;

  const categorySlugMatch = categorySlugs.find((item) => {
    const path = `/${item.value.split(' > ').join('/')}`;
    return path === currentPath;
  });

  const categoryMatch = categories.find((item) => {
    return item.oldPath === currentPath || item.oldPathNormal === currentPath;
  });

  if (categorySlugMatch) {
    return {
      props: {},
      redirect: {
        destination: `/rom/${categorySlugMatch.value.split(' > ').join('/')}`,
      },
    };
  }

  if (categoryMatch) {
    return {
      props: {},
      redirect: {
        destination: `/rom/${categoryMatch.oldPathNormal}`,
      },
    };
  }
  console.log('GET SANITY REDIRECT DATA');
  const sanityRedirect = await configuredSanityClient.fetch<Redirect>(
    groq`*[_type == 'redirect' && pathname == $pathname][0]`,
    {
      pathname: `/${slugs.join('/')}`,
    }
  );

  if (sanityRedirect?.destination) {
    return {
      props: {},
      redirect: {
        destination: sanityRedirect.destination,
      },
    };
  }

  if (slugs.length >= 1) {
    const objectId = historicPaths.find(
      (item) => item.historicPath === currentPath
    )?.objectID;

    if (objectId) {
      const index = searchClient.initIndex(ALGOLIA_INDEX_NAME);

      const algoliaProduct = await index
        .getObject<FagmoblerAlgoliaProduct>(objectId)
        .catch(() => {
          return null;
        });

      if (algoliaProduct) {
        newUrl = getCanonicalPath(algoliaProduct);
      } else {
        console.warn('ObjectID provided, but does not exist', currentPath);
        return null;
      }
    } else {
      console.warn('No objectID', currentPath);
      return null; // 404
    }
  }

  return {
    props: {},
    redirect: {
      destination: newUrl,
    },
  };
};
